import { PlenaryEndPage } from '@hendrx/core/plenary/pages/PlenaryEndPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/lobby/plenary-ended')({
  component: PlenaryEndPage
});
